interface ChipProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export const Chip: React.FC<ChipProps> = ({ label, active = false, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="h-8 rounded-full px-3 text-[13px] whitespace-nowrap font-medium transition-all"
      style={{
        backgroundColor: active ? 'var(--accent)' : 'var(--bg-secondary)',
        color: active ? 'white' : 'var(--text-secondary)',
      }}
    >
      {label}
    </button>
  );
};
